var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRetailOrderButton = function SvgRetailOrderButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#retailOrderButton_svg__clip0_9395_68664)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 8H3.333v.667h9.334V8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 5.333A.667.667 0 0016 4.667V3.333a.667.667 0 00-.667-.666H14.4L13.501.419A.667.667 0 0012.882 0H3.118a.667.667 0 00-.619.419L1.6 2.667H.667A.667.667 0 000 3.333v1.334c0 .367.299.666.667.666h.666v10H0V16h16v-.667h-1.333v-10h.666zM3.118.667h9.764l.8 2H2.318l.8-2zm-2.451 4V3.333h14.666v1.334H.668zM4 15.333v-4.666h2.667v4.666H4zm5.333 0v-4.666H12v4.666H9.333zm4.667 0h-1.333v-4.666A.667.667 0 0012 10H9.333a.667.667 0 00-.666.667v4.666H7.333v-4.666A.667.667 0 006.667 10H4a.667.667 0 00-.667.667v4.666H2v-10h12v10z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retailOrderButton_svg__clip0_9395_68664"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgRetailOrderButton;